"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);












const getOrgConsentActions = _utils.createAsyncActions('GetOrgConsent')
const getConsentTurnOnCountsActions = _utils.createAsyncActions('GetConsentTurnOnCounts')
const turnOnOrgConsentActions = _utils.createAsyncActions('TurnOnOrgConsent')
const getOrgConsentWaitingActions = _utils.createAsyncActions('GetOrgConsentWaiting')
const turnOffOrgConsentActions = _utils.createAsyncActions('TurnOffOrgConsent')
const exportOrgConsentHistoryActions = _utils.createAsyncActions('ExportOrgConsentHistory')
const getPatientConsentActions = _utils.createAsyncActions('GetPatientConsent')
const recordPatientConsentActions = _utils.createAsyncActions('RecordPatientConsent')

// Org admins only, in orgs with the CONSENT bit.
const getOrgConsent = (req) =>
  _helpers.wsCommand('GetOrgConsent', getOrgConsentActions, req, null)

const getConsentTurnOnCounts = (req) =>
  _helpers.wsCommand('GetConsentTurnOnCounts', getConsentTurnOnCountsActions, req, null)

const turnOnOrgConsent = (req) =>
  _helpers.wsCommand('TurnOnOrgConsent', turnOnOrgConsentActions, req, null)

const getOrgConsentWaiting = (req) =>
  _helpers.wsCommand('GetOrgConsentWaiting', getOrgConsentWaitingActions, req, null)

const turnOffOrgConsent = (req) =>
  _helpers.wsCommand('TurnOffOrgConsent', turnOffOrgConsentActions, req, null)

// The consent history CSV's download link.
const getOrgConsentHistoryURL = (req) =>
  _helpers.wsCommand('ExportOrgConsentHistory', exportOrgConsentHistoryActions, req, null)
    .then(r => _client2.default.getFileLink(r))
    .then(r => r.Link)

// Any org member who can see the patient.
const getPatientConsent = (req) =>
  _helpers.wsCommand('GetPatientConsent', getPatientConsentActions, req, null)

const recordPatientConsent = (req) =>
  _helpers.wsCommand('RecordPatientConsent', recordPatientConsentActions, req, null)

exports. default = {
  getOrgConsent,
  getConsentTurnOnCounts,
  turnOnOrgConsent,
  getOrgConsentWaiting,
  turnOffOrgConsent,
  getOrgConsentHistoryURL,
  getPatientConsent,
  recordPatientConsent,
}
